import { LanguageFlag } from '@/components/ui/LanguageFlag'
import { englishName } from '@/content/languages'
import type { Language } from '@/types/language'

interface LanguageHeaderProps {
  language: Language
}

/**
 * Language identity header (research D9). Large flag, native name in the display serif,
 * uppercase English label, and the description intro paragraph.
 */
export function LanguageHeader({ language }: LanguageHeaderProps) {
  return (
    <header>
      <div className="flex items-center gap-4">
        <LanguageFlag isoCode={language.iso_code} size="l" />
        <div>
          <h1 className="font-display text-3xl sm:text-4xl text-heading leading-tight">
            {language.name}
          </h1>
          <p className="font-mono text-xs uppercase tracking-widest text-muted mt-1">
            {englishName(language.iso_code, language.name)}
          </p>
        </div>
      </div>
      {language.description && (
        <p className="font-serif text-body leading-relaxed text-lg mt-6 max-w-2xl">
          {language.description}
        </p>
      )}
    </header>
  )
}
